// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ut6pwpYiRa6RCNLKZcVeXQ\\=\\={padding-top:var(--xds-spacing-a)}@media screen and (max-width: 720px){.ut6pwpYiRa6RCNLKZcVeXQ\\=\\={padding-left:var(--xds-spacing-a);padding-right:var(--xds-spacing-a)}}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardOrderList/DashboardOrderList.module.scss"],"names":[],"mappings":"AAEA,4BAEI,gCAAA,CAGA,qCALJ,4BAMQ,iCAAA,CACA,kCAAA,CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DashboardOrderList": "ut6pwpYiRa6RCNLKZcVeXQ=="
};
export default ___CSS_LOADER_EXPORT___;
